<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Ajout de plusieurs bâtiments et compteurs",
        },
    },
})

// ================================
// EMITS
// ================================
const emit = defineEmits<{
    (e: "done:form", type?: string): void
}>()

/** Visibilité du dialog (v-model) */
const visible = defineModel<boolean>("visible", { default: false })

// ================================
// INTERACTIONS
// ================================
/**
 * Ferme le dialog et émet done:form à la fin du parcours
 * @param type - 'invitation' si l'utilisateur a quitté depuis l'étape Envoi invitation
 */
function onDoneForm(type?: string): void {
    visible.value = false
    emit("done:form", type)
}
</script>

<template>
    <BaseDialog
        v-model:visible="visible"
        modal
        :closable="true"
        dismissable-mask
        position="top"
        :style="{ width: '60vw' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
        content-class="overflow-y-auto max-h-[85vh]"
    >
        <template #header>
            <h2 class="text-lg text-primary font-semibold w-full">
                {{ t("title") }}
            </h2>
        </template>
        <div class="pb-8">
            <SourceMultiAppendForm @done:form="onDoneForm" />
        </div>
    </BaseDialog>
</template>
